export var measuredCookieReduxKey = '@@measuredCookie';
export var actionKey = '@@measuredCookie';
export var cookieKey = 'td';
//# sourceMappingURL=constants.js.map